import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from 'react-router-dom';
import ProductCategory1 from '../non-pod-courier-bags/Product-category-section/product-category1';
import ProductCategory2 from '../non-pod-courier-bags/Product-category-section/product-category2';
// import ProductCategory3 from '../non-pod-courier-bags/Product-category-section/product-category3';
// import ProductCategory4 from '../non-pod-courier-bags/Product-category-section/product-category4';
// import ProductCategory5 from '../non-pod-courier-bags/Product-category-section/product-category5';
const NonPodCourierBags = () => {
  const navigate=useNavigate()
  return (
    <>
    <div className="container-fluid  bags-container d-flex align-items-center" >
      <div className="row justify-content-center w-100">
        <div className="col-12 col-lg-10">
          <div className="card-banner">
            <div className="row g-0">
              {/* Left side with single product image */}
              <div className="col-md-6  d-flex align-items-center justify-content-center p-5" >
                <img
                  src="/assets/products-with-logo/courier-bags/non-pod-large (1).jpeg"
                  className="img-fluid"
                  alt="non-pod-couriar-bag"
                  style={{
                    maxWidth: '100%',
                    height: 'auto',
                    objectFit: 'contain'
                  }}
                />
              </div>
              
              {/* Right side content */}
              <div className="col-md-6 d-flex align-items-center">
              <div className="p-4 p-lg-5 w-100">
    <small className="text-black text-uppercase letter-spacing-1 mb-2 d-block">
        Simple, standard, economical
    </small>
    
    <h2 className="main-heading display-5 fw-bold text-dark mb-4">
        Non-POD Courier Bags
    </h2>
    
    <p className="product-each-desc text-black mb-4 lead">
        Standard courier bags offering basic shipping protection without tracking features, perfect for routine deliveries and cost-effective shipping solutions where proof of delivery isn't required.
    </p>

                  
                  <div className="text-center mb-4">
                    <button 
                      className="btn btn-dark btn-sm rounded-pill text-uppercase mx-auto" 
                      style={{ 
                        width: '100px',
                        fontSize: '0.6rem',
                        padding: '10px 2px',
                        lineHeight: '1.2',
                        display: 'block'
                      }} onClick={()=>{navigate('/contact')}}>
                      Contact Us
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ProductCategory1/>
    <ProductCategory2/>
{/*  
    <ProductCategory3/>
     <ProductCategory4/>
    <ProductCategory5/> */}
</>
  );
};

export default NonPodCourierBags;